import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { AnimatePresence } from "framer-motion";
import { CartProvider } from "@/context/CartContext";
import AgeGate from "@/components/AgeGate";
import Header from "@/components/Header";
import CartDrawer from "@/components/CartDrawer";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import ProductDetail from "@/pages/ProductDetail";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import { Toaster } from "@/components/ui/sonner";

function App() {
  const [verified, setVerified] = useState(
    () => localStorage.getItem("aetheria_age_verified") === "true"
  );

  useEffect(() => {
    if (!verified) return;
    const lenis = new Lenis({ lerp: 0.09 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, [verified]);

  const handleVerify = () => {
    localStorage.setItem("aetheria_age_verified", "true");
    setVerified(true);
  };

  return (
    <div className="App">
      <div className="grain-overlay" />
      <CartProvider>
        <BrowserRouter>
          <AnimatePresence>
            {!verified && <AgeGate key="age-gate" onAccept={handleVerify} />}
          </AnimatePresence>
          <Header verified={verified} />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/product/:slug" element={<ProductDetail />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
            </Routes>
          </main>
          <Footer />
          <CartDrawer />
        </BrowserRouter>
      </CartProvider>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
